import { useEffect, useState, useCallback } from 'react';

export function useTelegram() {
  const [isReady, setIsReady] = useState(false);
  const [isTelegramEnvironment, setIsTelegramEnvironment] = useState(false);
  
  const tg = window.Telegram?.WebApp;
  
  useEffect(() => {
    if (tg) {
      setIsTelegramEnvironment(true);
      tg.ready();
      tg.expand();
      setIsReady(true);
    } else {
      // Не в Telegram — для разработки
      setIsReady(true);
    }
  }, [tg]);
  
  const hapticFeedback = useCallback((type: 'success' | 'error' | 'warning' | 'light' | 'medium' | 'heavy') => {
    if (!tg?.HapticFeedback) return;
    
    if (type === 'success' || type === 'error' || type === 'warning') {
      tg.HapticFeedback.notificationOccurred(type);
    } else {
      tg.HapticFeedback.impactOccurred(type);
    }
  }, [tg]);
  
  const showMainButton = useCallback((text: string, onClick: () => void) => {
    if (!tg?.MainButton) return;
    
    tg.MainButton.text = text;
    tg.MainButton.onClick(onClick);
    tg.MainButton.show();
  }, [tg]);
  
  const hideMainButton = useCallback(() => {
    if (!tg?.MainButton) return;
    tg.MainButton.hide();
  }, [tg]);
  
  const showBackButton = useCallback((onClick: () => void) => {
    if (!tg?.BackButton) return;
    
    tg.BackButton.onClick(onClick);
    tg.BackButton.show();
  }, [tg]);
  
  const hideBackButton = useCallback(() => {
    if (!tg?.BackButton) return;
    tg.BackButton.hide();
  }, [tg]);
  
  const close = useCallback(() => {
    if (!tg) return;
    tg.close();
  }, [tg]);
  
  const openLink = useCallback((url: string, options?: { try_instant_view?: boolean }) => {
    if (!tg?.openLink) {
      window.open(url, '_blank');
      return;
    }
    tg.openLink(url, options);
  }, [tg]);
  
  const openTelegramLink = useCallback((url: string) => {
    if (!tg?.openTelegramLink) {
      window.open(url, '_blank');
      return;
    }
    tg.openTelegramLink(url);
  }, [tg]);
  
  return {
    tg,
    isReady,
    isTelegramEnvironment,
    user: tg?.initDataUnsafe?.user || null,
    initData: tg?.initData || '',
    colorScheme: tg?.colorScheme || 'dark',
    viewportHeight: tg?.viewportHeight || window.innerHeight,
    themeParams: tg?.themeParams || {},
    
    // Methods
    hapticFeedback,
    showMainButton,
    hideMainButton,
    showBackButton,
    hideBackButton,
    close,
    openLink,
    openTelegramLink,
  };
}
